export const siteURL = "https://api.niskimeni.rs";
export const baseURL = `${siteURL}/api`;
export const baseApiUrl = `${siteURL}/api/`;
export const googleMAPSkey = "AIzaSyDvTVJ0MN8BJUELevE3Ea8ElcACusywhoU"